import * as THREE from 'three';
import { gsap } from 'gsap';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

import Scene from './scene';
import LogoScene from './LogoScene';
import { convertArray } from 'three/src/animation/AnimationUtils';

const LOADER = new GLTFLoader();
const loadModel = (model) => {
	return new Promise((resolve, reject) => {
		LOADER.load(
			`/wp-content/themes/redboxmediarefonte2022/resources/scripts/vendor/logoredbox.gltf`,
			(gltf) => resolve(gltf.scene)
		);
	});
};
function deg(radians) {
	var pi = Math.PI;
	return radians * (180 / pi);
}

export function load3DLogo({ container, dark = false }) {
	return loadModel('logoredbox').then((obj) => {
		const onMouseMove = (e) => {
			const xRot = (-1 + 2 * (e.clientY / window.innerHeight)) / 3;
			const yRot = Math.abs(e.clientX / window.innerWidth);
			gsap.to(obj.rotation, 0.3, { y: yRot, x: xRot });
		};

		const setDarkTexture = (model) => {
			model.traverse((item) => {
				if (item.material?.name === 'TextTexture') {
					item.material.emissive = new THREE.Color(0x000000);
				}
			});
		};

		const scene_logo = new LogoScene({
			containerId: container,
			objects: [obj],
			width:
				container && typeof container == 'string'
					? $('#' + container).width()
					: $(container).width(),
			cameraPosX: dark ? -0.2 : 0,
		});
		scene_logo.spawn();

		if (dark) {
			scene_logo.camera.position.z = 4;
			scene_logo.camera.position.y = 0;
			setDarkTexture(obj);
		} else {
			scene_logo.camera.position.z = 3;
			scene_logo.camera.position.y = 0.2;
		}

		window.addEventListener('mousemove', onMouseMove);
		return scene_logo;
	});
}

window.addEventListener('load', () => {
	//instantiation de notre scene
	const scene = new Scene({
		containerId: 'cube',
		width: 65,
		height: 65,
	});

	scene.spawn();

	if (
		$('#3D_logo').length > 0 &&
		window.matchMedia('(min-width: 1100px)').matches
	) {
		load3DLogo({ container: '3D_logo' });
	}
});
